import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { Home } from "./pages/Home";
import { PostDetail } from "./pages/PostDetail";
import { Editor } from "./pages/Editor";
import { Login } from "./pages/Login";
import { UserProfile } from "./pages/UserProfile";
import { McpManual } from "./pages/McpManual";
import { Settings } from "./pages/Settings";
import { Assistant } from "./pages/Assistant";
import { Notifications } from "./pages/Notifications";
import { Follows } from "./pages/Follows";
import { UserCollection } from "./pages/UserCollection";

function AppContent() {
  const [theme, setTheme] = useState<"light" | "dark">(() => {
    if (typeof window === "undefined") return "light";
    if (localStorage.getItem("theme") === "dark") return "dark";
    if (localStorage.getItem("theme") === "light") return "light";
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
  });

  useEffect(() => {
    const root = document.documentElement;
    if (theme === "dark") {
      root.classList.add("dark");
    } else {
      root.classList.remove("dark");
    }
    localStorage.setItem("theme", theme);
  }, [theme]);

  const toggleTheme = () => setTheme((t) => (t === "light" ? "dark" : "light"));

  return (
    <div className="min-h-screen flex flex-col bg-gradient-page relative">
      <Header theme={theme} toggleTheme={toggleTheme} />
      <main className="flex-1 relative z-10 pt-16">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/articles" element={<Home articlesOnly />} />
          <Route path="/post" element={<PostDetail />} />
          <Route path="/editor" element={<Editor />} />
          <Route path="/assistant" element={<Assistant />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Login initialMode="register" />} />
          <Route path="/users/:id" element={<UserProfile />} />
          <Route path="/users/:id/follows" element={<Follows />} />
          <Route path="/users/:id/collections/:collectionId" element={<UserCollection />} />
          <Route path="/notifications" element={<Notifications />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/admin" element={<Navigate to="/settings?tab=categories" replace />} />
          <Route path="/mcp" element={<McpManual />} />
          <Route path="/api-docs" element={<McpManual />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}
